import { ValidationStateEnum } from '../enums/validation-states.enum';
import { DocUserInterface } from '../interfaces/doc-user.interface';
import { DocumentValidationInterface } from '../interfaces/document-validation.interface';

export class DocumentValidation {
  /**
   * Id.
   */
  id: number;

  /**
   * State.
   */
  state: ValidationStateEnum;

  /**
   * Validator
   */
  validator: DocUserInterface;

  /**
   * Creation date.
   */
  creationDate: Date;

  /**
   * Attachment
   */
  attachment: string;

  /**
   * DocumentValidation constructor.
   *
   * @param data Data.
   */
  constructor(data: DocumentValidationInterface) {
    this.id = data.id;
    this.state = data.status;
    this.validator = data.validator;
    this.creationDate = data.created_at;
    this.attachment = data.attachment;
  }
}
